<lib-gerer-mes-beneficiaires  [configuration]="configuration" [fileNamePattern]="fileNamePattern"></lib-gerer-mes-beneficiaires>
